import { TRANSITION_END } from '../core'

/*
* Hero slider
*/

function setHeroContent(content, firstLoad) {
  let heroContent = $('.carousel--style--hero .carousel__toolbar .card-hero__content-holder'),
  hero = $('.carousel--style--hero .carousel__toolbar .card-hero__content')
  heroContent.find('.card-hero__title').on(TRANSITION_END, function() {
    $(this).remove()
  }).addClass('leaving')
  hero.find('.card-hero__cta').fadeOut(200, function() {
    $(this).remove()
  })
  heroContent.find('.card-hero__cta').fadeOut(200, function() {
    $(this).remove()
  })
  heroContent.append(content.find('.card-hero__title'))
  if (firstLoad) {
    hero.append(content.find('.card-hero__cta'))
  } else {
    heroContent.append(content.find('.card-hero__cta').hide())
  }
  setTimeout(function() {
    heroContent.find('.card-hero__title').addClass('arriving')
    heroContent.find('.card-hero__cta').fadeIn(350)
  }, 50)
}

export default {
  speed: 550,
  rewind: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    768: {
      slidesPerView: 1,
      spaceBetween: 0,
    }
  },
  on: {
    init: function(swiper) {
      swiper.$el.find('.carousel__toolbar').addClass('carousel__toolbar--active')
      swiper.$el.find('.swiper-pagination').attr('data-active-index', swiper.activeIndex)
      setTimeout(function() {
        let currentSlide = swiper.slides[swiper.activeIndex],
        slideContent = $(currentSlide).find('.card-hero__content')
        setHeroContent(slideContent.clone(), true)
      }, 650)
    },
    slideChangeTransitionStart: function(swiper) {
      swiper.$el.find('.swiper-pagination').attr('data-active-index', swiper.activeIndex)
      let currentSlide = swiper.slides[swiper.activeIndex],
      slideContent = $(currentSlide).find('.card-hero__content')
      setHeroContent(slideContent.clone(), false)
    },
  },
}
